import { useRoof } from '../../../../hooks/state/useRoof'
import { useMeasures } from '../../../../hooks/state/useMeasures'
import { Shape } from 'three'
import { Helper } from '../../../../classes/helper'
import { CachedMeshPhysicalMaterial } from '../../../material/cachedMeshPhysicalMaterial'
import { useMarquee } from '../../../../hooks/state/useMarquee'

export const AttachedBar = (): JSX.Element | null => {
  const { userWidth, userHeight, offsetRoofLog, attachedSize, userAngle } =
    useMeasures()
  const { color, defaultRoofCoverings } = useRoof()
  const { marqueeTyp } = useMarquee()

  const shape = new Shape()
  shape
    .moveTo(0, 0.07)
    .lineTo(0, 0.049)
    .lineTo(-attachedSize.z, 0.03)
    .lineTo(-attachedSize.z, 0.025)
    .lineTo(0, 0.03)
    .lineTo(0, 0)

  const extrudeSettings = {
    curveSegments: 1,
    steps: 1,
    depth: userWidth,
    bevelEnabled: false,
  }
  const capPos =
    Helper.calculateTriangleSideLength(90, userAngle, 0.11).a - 0.11 > 0.2
      ? Helper.calculateTriangleSideLength(90, userAngle, 0.11).a - 0.11
      : 0

  return (
    <group position={[0, userHeight! + offsetRoofLog.c, attachedSize.z / 2]}>
      <mesh
        castShadow={true}
        receiveShadow={true}
        position={[0, -attachedSize.y / 2, 0]}
      >
        <boxGeometry args={[attachedSize.x, attachedSize.y, attachedSize.z]} />
        <CachedMeshPhysicalMaterial color={color} />
      </mesh>
      {defaultRoofCoverings && !marqueeTyp.hasIntergrateBox && (
        <group position={[0, 0.005, -capPos]}>
          <mesh
            rotation={[
              Helper.convertAngleToRadiant(2),
              Helper.convertAngleToRadiant(90),
              0,
            ]}
            position={[-userWidth / 2, -0.025, -attachedSize.z / 2]}
            castShadow={true}
          >
            <extrudeGeometry
              attach="geometry"
              args={[shape, extrudeSettings]}
            />
            <CachedMeshPhysicalMaterial color={color} />
          </mesh>

          <mesh
            rotation={[Helper.convertAngleToRadiant(50), 0, 0]}
            position={[0, -0.0015, attachedSize.z / 2 + capPos]}
            castShadow={true}
            receiveShadow={true}
          >
            <boxGeometry args={[userWidth!, 0.004, 0.018]} />
            <CachedMeshPhysicalMaterial
              color={'white'}
              transparent
              opacity={0.5}
            />
          </mesh>
        </group>
      )}
    </group>
  )
}
